export const GA_TRACKING_ID = 'G-5JZ5WQV2ZB';

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = (url) => {
  window.gtag('event', 'page_view', {
    page_path: url,
  });
};
